<template>
  <div class="wt2-sg wt2-masthead-story-back-icon" @click="onClick" v-once>
    <i class="wticon wticon-chevron-left1" /> Back
  </div>
</template>

<script>
import app from 'app';
import Vue from 'vue';

export default Vue.extend({
  methods: {
    onClick: _.debounce(
      function () {
        app.storyController.exit({ type: 'exit' });
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),
  },
});
</script>
